<template>
  <!-- 搜索方法 -->
  <div class="customTree" id="customTree">
    <Input
      v-if="needSearch"
      v-model="inputVal"
      @on-change="change"
      :icon="inputVal ? 'md-close-circle' : ''"
      @on-click="iconClick"
      placeholder="请输入"
    />
    <Button
      v-if="needButton"
      class="button"
      type="primary"
      @click="handleOpenModal"
    >
      新增{{ createButtonTitle }}
    </Button>
    <ul class="tree-list">
      <div v-for="item in dataSource" :key="item.id + item.relationId">
        <TreeItem :itemData="item" @change-active="changeActive" />
      </div>
    </ul>
  </div>
</template>
<script>
import TreeItem from './menu-tree-item.vue';
export default {
  components: { TreeItem },
  props: {
    needSearch: {
      type: Boolean,
      default: false
    },
    needButton: {
      type: Boolean,
      default: false
    },
    dataSource: {
      type: Array,
      default: () => []
    },
    createButtonTitle: {
      type: String,
      default: ''
    },
    activedTree: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      inputVal: '',
      timer: null
    };
  },
  computed: {},
  methods: {
    changeActiveTree(currentTree, allData) {
      // 首先判断第一层有没有对应的id ， 如果有就直接更改状态，如果没有再找循环找children
      const hasItem = allData.find(
        item => item.id == currentTree.id && item.pid == currentTree.pid
      );
      if (hasItem) {
        hasItem.active = true;
      } else {
        allData.forEach(item => {
          if (item.children && item.children.length > 0) {
            this.changeActiveTree(currentTree, item.children);
          }
        });
      }
    },
    change(e) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        const { value } = e.target;
        this.$emit('handleOnSearch', value);
      }, 500);
    },
    iconClick(e) {
      this.inputVal = '';
      this.$emit('handleOnSearch', '');
    },
    handleOpenModal() {
      this.$emit('handleOpenModal', 'create');
    },
    changeActive(d) {
      if (d.active) return;
      this.departmentId = d.id;
      this.$emit('handleTreeClick', d);
    },
    resetActive(tlist) {
      const _self = this;
      tlist.forEach(function(v, i) {
        v.active = false;
        if (v.children && v.children.length > 0) {
          _self.resetActive(v.children);
        }
      });
    }
  },
  watch: {
    activedTree: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal && newVal.id != oldVal.id) {
          // 先吧所有的都给关闭了
          this.resetActive(this.dataSource);
          // 这都找到对应的打开
          this.changeActiveTree(newVal, this.dataSource);
        }
        if (newVal && newVal.id && newVal.id == oldVal.id) {
          if (newVal.pid != oldVal.pid) {
            this.resetActive(this.dataSource);
          }
          // 如果id一样的话，就证明是搜索为空的时候
          this.changeActiveTree(newVal, this.dataSource);
        }
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  }
};
</script>
<style scoped>
.button {
  padding: 0px 10px;
  margin: 10px 0;
}
.tree-list {
  width: 100%;
}
.tree-list .line {
  width: 100%;
  border-bottom: 1px solid #ccc;
  margin: 1px 0;
}
.customTree {
  background: #fff;
  width: 250px;
  padding: 10px;
  height: 100%;
  overflow-y: scroll;
  margin-right: 15px;
}
.customTree ::v-deep .ivu-tree-children {
  margin: 10px 0;
  font-size: 16px;
}
</style>
